(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["affiliate-form"]) return;
  try {
    

(function() {
  const FORM_STATE = {
    DEFAULT: 'default',
    PROCESSING: 'processing',
    SUCCESS: 'success'
  }

  const MAX_FILE_SIZE = 52428800;

  class CustomForm {
    constructor(selector, urls, method = 'GET') {
      this.form = document.querySelector(selector);
      this.state = this.formState;
      this.urls = urls;
      this.form.onsubmit = async (e) => this.submit(e);
      this.method = method;
    }

    get formState() {
      return this.form.dataset.state;
    }

    set formState(state) {
      this.form.dataset.state = state;
      this.form.querySelector('button#submit-form').disabled = state != FORM_STATE.DEFAULT;
    }

    get formData() {
      return new FormData(this.form);
    }

    async submit(e) {
      e.preventDefault();
      this.formState = FORM_STATE.PROCESSING;

      if (this.method == 'GET') {
        this.submitForm();
      }
      if (this.method == 'POST') {
        this.submitFormPost(e.target);
      }

      return false;
    }

    async submitFormPost(target) {
      const data = await parseValues(target);
      const response = await fetch(this.urls[0], {
        method: 'POST',
        body: JSON.stringify(data)
      })
      const result = await response.json();
      if (result.result === 'success') {
        this.formState = FORM_STATE.SUCCESS;
      } else {
        this.handleError(result.error);
      }
    }

    submitForm() {
      const queryString = new URLSearchParams(this.formData).toString();

      for (const url of this.urls) {
        const urlWithParams = `${url}?${queryString}`;
        fetch(urlWithParams)
          .then(res => res.json())
          .then(data => {
            if (data.result === "success") {
              this.formState = FORM_STATE.SUCCESS;
            } else {
              this.handleError(data.error);
            }
          })
          .catch(error => this.handleError(error));
      }
    }

    handleError(error) {
      console.error(error);
      this.formState = FORM_STATE.DEFAULT;
      alert("Uh oh, something went wrong.... Try again?");
    }
  }

  const parseValues = async (target) =>
    Object.assign(
      ...(await Promise.all(
        [...target].map(
          (obj) =>
            new Promise(async (res) => {
              const temp = {[obj.name]: ""};
              if (obj.type == "radio") {
                if (obj.checked === true) {
                  temp[obj.name] = obj.value;
                }
              } else if (obj.type == "checkbox") {
                temp[obj.name] = obj.checked;
              } else if (obj.type == "file") {
                const files = obj.files;
                temp[obj.name] = await (async (files) => {
                  return await Promise.all(
                    [...files].map(
                      (file) =>
                        new Promise((resolve, reject) => {
                          const fr = new FileReader();
                          fr.onload = (f) =>
                            resolve({
                              filename: file.name,
                              mimeType: file.type,
                              bytes: [...new Int8Array(f.target.result)],
                            });
                          fr.onerror = (err) => reject(err);
                          fr.readAsArrayBuffer(file);
                        })
                    )
                  );
                })(files).catch((err) => console.log(err));
              } else {
                temp[obj.name] = obj.value;
              }
              res(temp);
            })
        )
      ))
    );

  new CustomForm('form.affiliate-form', ['https://script.google.com/macros/s/AKfycbyfdtPgrP7NF_JdYZ_MHre11POhddTiEJFKBJ30WUhRwoSF3yA4h8oaXRKPTYA0xQvRUg/exec'], 'GET');
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["half-image-benefits-email"]) return;
  try {
    
(() => {
  const newsletterSignupForm = document.querySelector('#home-signup form.newsletter-signup__form');
  newsletterSignupForm.addEventListener('submit', event => {
    event.preventDefault();

    // Show successful signup element, regardless of whether or not it actually was successful
    const signupSuccess = document.querySelector('#home-signup div.newsletter-signup__success');
    newsletterSignupForm.style.display = 'none';
    signupSuccess.style.display = 'block';

    const email = event.target[1].value
    const data = {
      form_type: "customer",
      "contact[email]": email
    };

    const url = '/contact#contact_form';

    fetch(url, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })

    return false;
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["try-our-trampolines"] && !Shopify.designMode) return;
  try {
    
function scrollToProduct() {
  const productElement = document.querySelector('div.product-container');
  const navbarHeight = document.querySelector('header.navbar-container').offsetHeight;
  const y = productElement.offsetTop - navbarHeight;
  window.scroll({
    top: y,
    behavior: 'smooth'
  });
}

const buttonElement = document.querySelector('section.try-our-trampolines .button.primary');
buttonElement.onclick = e => {
  if (window.location.href.indexOf('/products/bungee-rebounders-mini-trampoline') > -1) {
    e.preventDefault();
    scrollToProduct();
  }
}

  } catch(e) { console.error(e); }
})();
})();
